import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { IMarketingCampaignStep } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-campaign-step-header',
  templateUrl: './campaign-step-header.component.html',
  styleUrl: './campaign-step-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule],
})
export class CampaignStepHeaderComponent {
  campaignStep = signal<WithRef<IMarketingCampaignStep> | undefined>(undefined);

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('campaignStep')
  set campaignStepSet(campaignStep: WithRef<IMarketingCampaignStep>) {
    if (campaignStep) {
      this.campaignStep.set(campaignStep);
    }
  }
}
